import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetosataracabs() {



const cardData = {
  keyword: "Pune to Satara Cabs",
  heading: "Lotus Cab: Pune to Satara Cabs",

  headingDescription:
    "Lotus Cab provides reliable and comfortable Pune to Satara Cabs for safe and scenic outstation travel. Whether you are planning a same-day return trip, weekend getaway, pilgrimage visit, or corporate journey, our well-maintained AC sedan and SUV fleet ensures a smooth ride. Our experienced chauffeurs are familiar with NH48 highway routes and popular attractions like Kaas Plateau and Thoseghar Waterfalls. We offer transparent per-km pricing with one-way and round-trip flexibility. With 24/7 booking assistance and doorstep pickup anywhere in Pune, we make your Pune to Satara taxi service affordable, convenient, and stress-free.",

  top: "Top Places to Visit in Satara with Lotus Cab",

  topPlaces: [
    {
      title: "Kaas Plateau",
      description:
        "Kaas Plateau is a UNESCO World Natural Heritage Site known as the Valley of Flowers of Maharashtra. During monsoon, it blooms with colorful wildflowers. Nature lovers and photographers frequently visit this scenic location. It offers breathtaking views and fresh mountain air. Ideal for weekend trips from Pune. A must-visit attraction near Satara."
    },
    {
      title: "Thoseghar Waterfalls",
      description:
        "Thoseghar Waterfalls is one of the tallest waterfalls in Maharashtra. It becomes spectacular during the monsoon season. Surrounded by lush greenery and hills, it offers stunning views. Popular for family picnics and nature photography. Safe viewing platforms are available. A refreshing getaway near Satara."
    },
    {
      title: "Sajjangad Fort",
      description:
        "Sajjangad Fort is a spiritual and historical landmark associated with Samarth Ramdas Swami. The fort offers peaceful surroundings and scenic valley views. Pilgrims frequently visit this sacred place. The climb is moderate and rewarding. Ideal for spiritual travelers and families. A meaningful stop in Satara."
    },
    {
      title: "Ajinkyatara Fort",
      description:
        "Ajinkyatara Fort stands proudly over Satara city. It offers panoramic views of the surrounding region. The fort has historical significance from Maratha history. Popular among trekking enthusiasts. Ideal for sunrise and sunset visits. A historic gem in Satara."
    },
    {
      title: "Chalkewadi Windmill Farm",
      description:
        "Chalkewadi Windmill Farm is known for its scenic wind turbines across rolling hills. It offers a unique landscape view. Popular among photographers and bikers. The cool breeze and open space create relaxing atmosphere. Ideal for group outings. A beautiful countryside attraction."
    },
    {
      title: "Lingmala Waterfall",
      description:
        "Lingmala Waterfall is located on the route to Mahabaleshwar via Satara. It offers picturesque views and trekking opportunities. Surrounded by greenery and hills. Popular during monsoon season. Ideal for family and adventure trips. A scenic stop during travel."
    },
    {
      title: "Koyna Dam",
      description:
        "Koyna Dam is one of Maharashtra’s largest hydroelectric projects. It offers peaceful lake views and fresh air. Popular among tourists for nature and relaxation. Surrounded by forest and hills. Ideal for weekend travel. A serene attraction near Satara."
    },
    {
      title: "Char Bhinti (Pratapgad Route)",
      description:
        "Char Bhinti is a scenic viewpoint near Satara. It offers breathtaking views of valleys and hills. Popular among adventure seekers. Ideal for short treks and photography. Peaceful environment away from city noise. A perfect nature escape."
    }
  ],

  services: [
    {
      name: "Pune to Satara Taxi Service",
      description:
        "Reliable taxi service from Pune to Satara with professional drivers and clean vehicles. AC sedan and SUV options available. Transparent per-km pricing maintained. Safe highway travel ensured. Suitable for family and corporate trips. 24/7 booking assistance provided."
    },
    {
      name: "Pune to Satara One Way Cab",
      description:
        "Affordable one-way cab from Pune to Satara with clear billing. Pay only for single-side distance. Ideal for drop and relocation travel. Timely pickup from Pune locations. Comfortable ride guaranteed. Hassle-free booking process."
    },
    {
      name: "Pune to Satara Round Trip Taxi",
      description:
        "Flexible round-trip taxi service for Pune to Satara travel. Suitable for same-day return and weekend trips. Transparent fare breakdown provided. Spacious vehicles available. Professional chauffeurs ensure safe travel. Reliable return scheduling supported."
    },
    {
      name: "Affordable Pune to Satara Cab",
      description:
        "Budget-friendly cab service without compromising quality. Competitive per-km pricing available. Clean and sanitized vehicles ensured. Ideal for families and small groups. Transparent billing maintained. Comfortable outstation travel guaranteed."
    },
    {
      name: "Luxury Cab Pune to Satara",
      description:
        "Premium luxury cab options for executive and VIP travel. High-end vehicles available. Superior comfort and spacious interiors ensured. Professional drivers provided. Ideal for special occasions and corporate visits. Premium experience guaranteed."
    },
    {
      name: "SUV Taxi Pune to Satara",
      description:
        "Spacious SUV taxis for group and family travel. Extra luggage capacity included. Comfortable long-distance ride supported. Smooth highway performance ensured. Ideal for Kaas Plateau and waterfall trips. Safe and dependable journey."
    },
    {
      name: "Pune to Kaas Plateau Cab",
      description:
        "Dedicated cab service for Kaas Plateau sightseeing. Early morning pickup available. Professional drivers familiar with route. Safe monsoon travel ensured. Suitable for photography and family visits. Comfortable travel guaranteed."
    },
    {
      name: "Online Cab Booking Pune to Satara",
      description:
        "Easy online booking with instant confirmation. Secure payment options available. Flexible scheduling supported. Transparent pricing shared in advance. 24/7 customer support provided. Hassle-free travel planning ensured."
    }
  ],

  tableData: [
    ["Pune to Satara Cabs", "Pune to Satara Taxi Service"],
    ["Pune to Satara One Way Cab", "Pune to Satara Round Trip Taxi"],
    ["Pune to Satara Outstation Cab", "Affordable Pune to Satara Cab"],
    ["Luxury Cab Pune to Satara", "SUV Taxi Pune to Satara"],
    ["Sedan Cab Pune to Satara", "Cheap Pune to Satara Taxi"],
    ["Online Cab Booking Pune to Satara", "Pune to Kaas Plateau Cab"],
    ["Pune to Thoseghar Waterfall Taxi", "Family Trip Cab Pune to Satara"],
    ["Corporate Taxi Pune to Satara", "Same Day Return Cab Satara"],
    ["AC Taxi Pune to Satara", "Best Cab Service Pune to Satara"],
    ["Pune to Sajjangad Cab", "Pune to Mahabaleshwar via Satara Taxi"]
  ],

  whychoose: [
    {
      WhyChooseheading: "Safe Highway Travel",
      WhyChoosedescription:
        "Experienced drivers ensure safe and smooth NH48 highway journey."
    },
    {
      WhyChooseheading: "Transparent Per KM Pricing",
      WhyChoosedescription:
        "Clear fare breakdown with no hidden charges."
    },
    {
      WhyChooseheading: "One-Way & Round Trip Flexibility",
      WhyChoosedescription:
        "Flexible drop and return trip options available."
    },
    {
      WhyChooseheading: "Well-Maintained AC Fleet",
      WhyChoosedescription:
        "Clean and regularly serviced vehicles for comfortable travel."
    },
    {
      WhyChooseheading: "Tour-Friendly Service",
      WhyChoosedescription:
        "Ideal for Kaas Plateau, Thoseghar, and pilgrimage visits."
    },
    {
      WhyChooseheading: "24/7 Booking Support",
      WhyChoosedescription:
        "Round-the-clock assistance for booking and travel coordination."
    },
    {
      WhyChooseheading: "Family & Corporate Friendly",
      WhyChoosedescription:
        "Spacious vehicles for families and business travelers."
    },
    {
      WhyChooseheading: "Comfortable Long-Distance Ride",
      WhyChoosedescription:
        "Smooth and relaxing ride experience for outstation trips."
    }
  ]
};

const faqData = [
  { question: "How far is Satara from Pune?", answer: "The distance is approximately 115 km and takes around 2.5 to 3 hours." },
  { question: "Can I book same-day return cab?", answer: "Yes, same-day return option is available." },
  { question: "Are toll charges included?", answer: "Toll charges are usually billed separately and informed before booking." },
  { question: "Is SUV available for group travel?", answer: "Yes, SUV taxis are available for families and groups." },
  { question: "Can I visit Kaas Plateau?", answer: "Yes, Kaas Plateau sightseeing can be included in the trip." },
  { question: "Is online booking available?", answer: "Yes, online booking with instant confirmation is available." },
  { question: "Are vehicles AC?", answer: "Yes, AC vehicles are available for comfortable travel." },
  { question: "Do you provide round-trip service?", answer: "Yes, round-trip and one-way options are available." },
  { question: "Is night travel possible?", answer: "Yes, 24/7 taxi service including night travel is available." },
  { question: "Do you offer corporate taxi service?", answer: "Yes, corporate and executive travel services are available." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Prakash Kulkarni",
    feedback:
      "Our Kaas Plateau trip from Pune was perfectly arranged. The driver was punctual and the SUV was comfortable. Excellent service.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neha Deshmukh",
    feedback:
      "Booked round-trip cab for Satara sightseeing. Transparent pricing and smooth ride made it stress-free. Highly recommended.",
    rating: 5
  },
  {
    id: 3,
    name: "Mr. Rahul Patil",
    feedback:
      "Corporate travel to Satara was handled professionally. Clean vehicle and timely pickup impressed me.",
    rating: 5
  }
];































































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Satara Cabs",
  "image": "https://lotuscab.com/assets/images/pune-to-satara-cabs.jpg", 
  "description": "Lotus Cab provides Pune to Satara cabs with one way, round trip, and outstation options. Travel comfortably to Satara, Kaas Plateau, Thoseghar Waterfall, Sajjangad, and Mahabaleshwar via Satara with sedan, SUV, and luxury taxis for family trips, corporate travel, and same-day return journeys, all with professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Lotus Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "6700"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3499",
    "availability": "https://schema.org/InStock",
    "url": "https://lotuscab.com/pune-to-satara-cabs"
  }
};





  return (
    <div>
      
<Helmet>
  <title>Contact: +91 8767592195 | Pune to Satara Cabs | Lotus Cab</title>
  <meta 
    name="description" 
    content="Book Pune to Satara cabs with Lotus Cab. Affordable one way, round trip & outstation taxis to Kaas Plateau, Thoseghar Waterfall, Sajjangad & Mahabaleshwar via Satara. Call +91 8767592195." 
  />
  <meta 
    name="keywords" 
    content="Pune to Satara Cabs, Pune to Satara Taxi Service, Pune to Satara One Way Cab, Pune to Satara Round Trip Taxi, Pune to Satara Outstation Cab, Affordable Pune to Satara Cab, Luxury Cab Pune to Satara, SUV Taxi Pune to Satara, Sedan Cab Pune to Satara, Cheap Pune to Satara Taxi, Online Cab Booking Pune to Satara, Pune to Kaas Plateau Cab, Pune to Thoseghar Waterfall Taxi, Family Trip Cab Pune to Satara, Corporate Taxi Pune to Satara, Same Day Return Cab Satara, AC Taxi Pune to Satara, Best Cab Service Pune to Satara, Pune to Sajjangad Cab, Pune to Mahabaleshwar via Satara Taxi" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>






 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/28.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetosataracabs;